// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"143":"app","858":"hello"}[chunkId] + "." + {"143":"71453fc0","858":"6e8bed25"}[chunkId] + ".css";
};